function clearCompareList() {
  const compareDivList = document.querySelectorAll("[data-compare]");
  compareDivList.forEach((item) => {
    const compareItemImage = item.querySelector(".compare-product-image");
    const compareItemTitle = item.querySelector(".compare-product-title");
    compareItemImage.setAttribute(
      "src",
      "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081"
    );
    compareItemTitle.innerHTML = "Please select product to compare";
  });
}
function updateCompare(compareList) {
  clearCompareList();
  compareList.forEach((item, index) => {
    const compareItem = document.querySelector(
      `.compare-product-content__item-${index}`
    );
    if (!compareItem) return;
    const products = document.getElementById(item.id);
    try {
      products.querySelector(".compare-checkbox").checked = true;
      products
        .querySelector(".compare-checkbox")
        .parentNode.classList.add("active");
    } catch (e) {}
    const compareItemImage = compareItem.querySelector(
      ".compare-product-image"
    );
    const compareItemTitle = compareItem.querySelector(
      ".compare-product-title"
    );
    const compareRemoveBtn = compareItem.querySelector(
      ".remove-compare-product"
    );
    compareRemoveBtn.setAttribute("data-id", item.id);
    compareItemImage.setAttribute("src", item.image);
    compareItemImage.style.display = "block";
    compareItemTitle.innerHTML = item.title.substring(0, 20) + "...";
  });
  if (compareList.length == 0) {
    clearCompareList();
  } else {
    document.querySelector(".compare-products").classList.remove("hidden");
    localStorage.setItem("compareList", JSON.stringify(compareList));
  }
}

function removeCompareItem(el) {
  const id = el.getAttribute("data-id");
  const products = document.getElementById(id);
  document.querySelector('[data-product-id="' + id + '"]').parentNode.classList.remove("active-compare-button");
  try {
    products.querySelector(".compare-checkbox").checked = false;
  } catch (e) {}
  const compareList = JSON.parse(localStorage.getItem("compareList"));
  const newCompareList = compareList.filter((item) => item.id != id);
  localStorage.setItem("compareList", JSON.stringify(newCompareList));
  updateCompare(newCompareList);
}

function clearCompareList() {
  const compareDivList = document.querySelectorAll("[data-compare]");
  document.querySelectorAll(".compare-checkbox").forEach((item) => {
    item.checked = false;
    item.parentNode.classList.remove("active");
  });
  compareDivList.forEach((item) => {
    const compareItemImage = item.querySelector(".compare-product-image");
    const compareItemTitle = item.querySelector(".compare-product-title");
    compareItemImage.setAttribute(
      "src",
      "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081"
    );
    compareItemTitle.innerHTML = "Please select product to compare";
  });
  document.querySelector(".compare-products").classList.add("hidden");
  localStorage.removeItem("compareList");
}
function collapseCompareModal() {
  document
    .querySelector(".compare-product-content")
    .classList.toggle("collapsed");
  document
    .querySelector(".collapse-compare-product svg")
    .classList.toggle("rotate");
}
